import { questionnairesPageInitialState } from '@reducers/initialState/questionnairesPage';
import { AnyAction } from 'redux';
import { questionnairesPageActionTypes } from '@actions/actionTypes/questionnairesPage';

export const questionnairesPageReducer = (
  state = questionnairesPageInitialState,
  action: AnyAction
) => {
  switch (action.type) {
    case questionnairesPageActionTypes.SET_QUESTIONNAIRES_FILTERS: {
      return { ...state, filters: { ...action.payload } };
    }
    default: {
      return state;
    }
  }
};
